import "google-fonts";
import "regenerator-runtime/runtime";

import Bodycomponent from "./component/bodycomponent.js";
import ChatBot from "./component/chatbot/ChatBot.jsx";

import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import { db } from "./config/firebase";

import { getDoc, doc } from "firebase/firestore";

function App() {
  const [float_visible, setfloat_Visible] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const [imageUrl, setImageUrl] = useState();
  const [title, setTitle] = useState();
  const [defualtMessages, setDefualtMessages] = useState([]);
  const [submenu, setSubmenu] = useState([]);
 
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");
  const exactParentDomain = urlParams.get("currentUrl");
  // console.log("-----------------------------------------------", currentDomain, "--------------------------------------");
  const shopId = currentDomain || "null";

  
  useEffect(() => {
    const fetchImage = async () => {
      try {
        // Replace `collectionName` and `documentId` with your Firestore structure
        const docRef = doc(db, "Shopify", shopId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setImageUrl(docSnap.data().Avatar_Link || "https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/whatsapp-media%2Fbot.png?alt=media&token=dee0144e-14ca-4e2d-99e8-ad03a6618559");
          setTitle(docSnap.data()?.Botname || "");
          const actionButtons = docSnap.data()?.ActionButtons ?? {}

          const submenu = docSnap.data()?.Submenu ?? []
          // console.log("this is submenu", submenu)

          setDefualtMessages(actionButtons)
         
          // here if exactParentDomain is available, and it contains /products/ then take action buttons from feild ProductButtons
          if (exactParentDomain && exactParentDomain.includes("/products/")) {
            const productButtons = docSnap.data()?.ProductButtons || [];
            setDefualtMessages(productButtons);
          }
         
          setSubmenu(submenu)
          
          const all_colors = docSnap.data()?.Color_Theme || {};
          const headerbackground = all_colors.primaryColor ?? "#dcf2d9";
          const headertext = all_colors.textSecondaryColor ?? "#000000";
          const bubble_user = all_colors.secondaryColor ?? "#3b892e";
          const send_button = all_colors.buttonTextColor ?? "#000";
          const footercolor = all_colors.primaryColor ?? "#5c583b";
          const textcolor = all_colors.textPrimaryColor ?? "#000000";
          const primarycolor = all_colors.primaryColor ?? "#000000";
          const accentColor = all_colors.accentColor ?? "#3b892e";
          const bubble_Sender = all_colors.bubble_Sender ?? "#000";
    
          const wholesectionbackground = all_colors.backgroundColor ?? "#fff";

          document.documentElement.style.setProperty("--color-text", textcolor);
          document.documentElement.style.setProperty("--color-bubble", bubble_user);
          document.documentElement.style.setProperty("--color-header", headerbackground);
          document.documentElement.style.setProperty("--color-footer", footercolor);
          document.documentElement.style.setProperty("--color-headertext", headertext);
          document.documentElement.style.setProperty("--color-primary1", primarycolor);
          document.documentElement.style.setProperty("--color-buttontext", send_button);
          document.documentElement.style.setProperty("--color-buttonbackground", accentColor);
          document.documentElement.style.setProperty("--color-chatbackground", wholesectionbackground);
          document.documentElement.style.setProperty("--color-bubbletext", bubble_Sender);

          // Set loading to false after everything is set
          setIsLoading(false);

        } else {
          // console.log("No such document!");
          setIsLoading(false);
        }
      } catch (error) {
        // console.error("Error fetching image: ", error);
        setIsLoading(false);
      }
    };

    fetchImage();
  }, [shopId]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'TOGGLE_CHAT_VISIBILITY') {
        setfloat_Visible(event.data.visible);
      }
    };

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // Send message to parent to control toggle button visibility
  useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        type: 'TOGGLE_CHAT_VISIBILITY',
        visible: !float_visible // Hide toggle button when chat IS visible
      }, '*');
    }
  }, [float_visible]);

  // Don't render until colors are loaded
  if (isLoading) {
    return null; // Or return a simple loading spinner with inline styles

  }

 return (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: 10,
      display: float_visible ? 'block' : 'none',
    }}
    className="krunk-bg-transparent"
  >
    <div className="krunk-flex krunk-justify-end md:krunk-justify-end krunk-items-end md:krunk-items-center krunk-h-full krunk-bg-transparent">
      {/* Mobile: items at bottom (krunk-items-end), Desktop: items centered (md:krunk-items-center) */}
      {float_visible && (
        <div className="krunk-flex krunk-flex-col krunk-h-full krunk-w-full krunk-max-w-md">
          <ChatBot 
            imageurl={imageUrl} 
            subMenu={submenu} 
            title={title} 
            actionButtons={defualtMessages} 
            setfloat_Visible={setfloat_Visible} 
            float_visible={float_visible}
          />
        </div>
      )}
    </div>
  </div>
);
}
export default App;
